<div
  class="gung-toast"
  [ngClass]="toast.customClass"
  [attr.data-state]="toast.state"
  [attr.data-ready]="ready"
  [attr.data-expanded]="isOpen"
  [attr.data-exiting]="!!toast.exiting"
  (pointerenter)="onPointerEnter($event)"
  (pointerleave)="onPointerLeave($event)"
  (pointerdown)="onPointerDown($event)"
  (click)="onClick($event)"
>
  <div class="gung-toast-header">
    <span class="gung-toast-badge">
      @switch (toast.state) {
        @case ('success') {
          <svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5" /></svg>
        }
        @case ('error') {
          <svg viewBox="0 0 24 24"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
        }
        @case ('warning') {
          <svg viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" /><line x1="12" x2="12" y1="8" y2="12" /><line x1="12" x2="12.01" y1="16" y2="16" />
          </svg>
        }
        @default {
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg>
        }
      }
    </span>
    <span class="gung-toast-title">
      @if (toast.link && !toast.message) {
        <a [routerLink]="toast.link.routerLink" [queryParams]="toast.link.queryParams">{{ toast.title | translate }}</a>
      } @else {
        {{ toast.title | translate }}
      }
    </span>
    <button type="button" class="gung-toast-close" [attr.aria-label]="'CLOSE' | translate" (click)="onClose($event)">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
    </button>
  </div>
  @if (toast.message) {
    <div class="gung-toast-body">
      <div class="gung-toast-body-inner">
        <div class="gung-toast-message">
          @if (toast.link) {
            <a [routerLink]="toast.link.routerLink" [queryParams]="toast.link.queryParams">{{ toast.message | translate }}</a>
          } @else {
            {{ toast.message | translate }}
          }
        </div>
      </div>
    </div>
  }
</div>
